import { TypographyOptions } from "@mui/material/styles/createTypography";

const typography: TypographyOptions = {
  fontFamily: `"Muli", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif`,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 700,
  fontWeightBold: 800,
  h1: {
    fontSize: "34px",
    fontWeight: 800,
    lineHeight: "40.8px",
  },
  h2: {
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "28.8px",
  },
  h3: {
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
  },
  subtitle1: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "28px",
    letterSpacing: "0.15px",
  },
  subtitle2: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "22px",
  },
  body1: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
  },
  body2: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
  },
  caption: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "19.92px",
    letterSpacing: "0.4px",
  },
  overline: {
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "uppercase",
    lineHeight: "31.92px",
    letterSpacing: "1px",
  },
};

export default typography;
